import script from "./left_line2.vue?vue&type=script&setup=true&lang=js"
export * from "./left_line2.vue?vue&type=script&setup=true&lang=js"

export default script